export const formatDate = (dateString, isDueDate = true) => {
  if (!dateString) {
    return isDueDate ? "No Due Date" : "No Date";
  }
  // Parse the date string into a Date object
  const date = new Date(dateString);
  // Create an array of month names to convert month number to month name
  const monthNames = [
    "January,",
    "February,",
    "March,",
    "April,",
    "May,",
    "June,",
    "July,",
    "August,",
    "September,",
    "October,",
    "November,",
    "December,",
  ];
  // Construct the formatted date string
  const formattedDate = `${isDueDate ? "" : ""} ${monthNames[date.getMonth()]} ${date.getDate()} ${date.getFullYear()}`;

  return formattedDate;
};

export function formatDateAsDayOrFutureDate(date) {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  // Remove the time portion of the dates for accurate comparison
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const tomorrowStart = new Date(tomorrow.getFullYear(), tomorrow.getMonth(), tomorrow.getDate());
  const dateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  if (dateStart.getTime() === todayStart.getTime()) {
    return "today";
  } else if (dateStart.getTime() === tomorrowStart.getTime()) {
    return "tomorrow";
  } else {
    const differenceInDays = (dateStart - todayStart) / (1000 * 60 * 60 * 24);
    if (differenceInDays >= 0 && differenceInDays <= 7) {
      return daysOfWeek[dateStart.getDay()];
    }
  }

  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
}

export const formatSubmittedDate = (dateString) => {
  if (!dateString) return "";

  try {
    // Parse the date string (assuming format like "2025-08-07T16:30:01.000Z")
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return dateString;
    }

    // Format date as "Feb 22, 2025"
    const formattedDate = date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });

    // Return the date
    return formattedDate;
  } catch (error) {
    // Return original string if parsing fails
    return dateString;
  }
};

export const formatSubmittedTime = (dateString) => {
  if (!dateString) return "";

  try {
    // Parse the date string (assuming format like "2025-08-07T16:30:01.000Z")
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return dateString;
    }

    // Format time as "11:47 PM"
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    // Return the time
    return formattedTime;
  } catch (error) {
    // Return original string if parsing fails
    return dateString;
  }
};

export const formatDateWithTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  // Format: Mar 15, 2024 at 2:30 PM
  const month = date.toLocaleDateString("en-US", { month: "short" });
  const day = date.getDate();
  const year = date.getFullYear();

  // Format time as H:MM AM/PM (no leading zero for hours)
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
  const displayMinutes = minutes.toString().padStart(2, "0");

  return `${month} ${day}, ${year} at ${displayHours}:${displayMinutes} ${ampm}`;
};

export const formatDateForDisplay = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export function parseDate(dateObj) {
  if (typeof dateObj === "object" && dateObj.year && dateObj.month && dateObj.day) {
    // Ignore milliseconds by not including them in the new Date() constructor
    return new Date(
      dateObj.year.low,
      dateObj.month.low - 1,
      dateObj.day.low,
      dateObj.hour ? dateObj.hour.low : 0,
      dateObj.minute ? dateObj.minute.low : 0,
      dateObj.second ? dateObj.second.low : 0,
      0 // Set milliseconds to 0
    );
  }
  let date = new Date(dateObj);
  date.setMilliseconds(0);
  return date;
}
